/** Contentful section typenames registered in layoutIndex (no component imports). */
export const LAYOUT_SECTION_TYPE_NAMES = new Set([
  "LayoutLogoGrid",
  "LayoutStatistics",
  "LayoutTestimonials",
  "LayoutInlineMedia",
  "LayoutItemizedList",
  "LayoutPricingCards",
  "LayoutRecommendations",
  "LayoutGeneral",
  "LayoutRelatedSubjects",
  "LayoutSubjectSpotlight",
  "LayoutCards",
  "LayoutCaseStudies",
  "LayoutFeatureCarousel",
  "LayoutWorkflow",
  "LayoutForm",
  "LayoutFaq",
  "LayoutBlogDigest",
  "LayoutDynamicCards",
  "LayoutTrueFaq",
  "LayoutIframe",
  "LayoutResourceGrid",
  "LayoutRainfocus",
  "MetaLocator",
  "LayoutDataTable",
  "LayoutComparisonTable",
  "LayoutDangerousHtmlEmbed",
  "LayoutSubnavigation",
  "LayoutProductFamily",
  "HeroLead",
  "HeroLeadSearch",
  "SimpleHero",
  "FlexibleHero",
  "FeaturedResources",
  "LayoutFeaturedResources",
  "SectionResourceGrid",
  "SectionBlogDigest",
  "SectionBlogSwitcher",
  "Tabs",
  "LayoutSearch",
  "LayoutRecommendationsLinked",
  "LayoutFilterableCards",
  "LayoutRichText",
])
